var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$attrs.component || _vm.$attrs.render,_vm._b({tag:"component",attrs:{"value":_vm.currentValue},on:{"input":_vm.handleInputEvent}},'component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }